import type { PlatformService } from '@/shared/api'

/** Ключи сервисов платформы — закрытый список из контракта (`PlatformService.key`). */
export type PlatformServiceKey = PlatformService['key']

/**
 * Находит сервис платформы по `key` — чтобы у ссылки «Сервис «Компании»» в поповере компаний
 * (prototype/Prototype.dc.html:163) и у «Личного кабинета» в меню профиля (строка 224) был
 * настоящий `href`, а не выдуманный.
 *
 * `key` типизирован контрактом (`enum: [bookings, companies, apartments, rc-adapter, id]`),
 * поэтому опечатка здесь — ошибка компиляции. Будь `key` свободной строкой, промах давал бы ТИХИЙ
 * отказ: ссылка просто не рисовалась бы, без ошибки и без лога. Список ключей в контракте закрыт
 * именно ради этого — см. описание `PlatformService.key`.
 *
 * `undefined` всё равно возможен: сервис может быть не подключён компании. Тогда ссылку не
 * рисуем вовсе — выдумывать адрес нельзя, а вести в никуда тем более.
 */
export function findService(
  services: readonly PlatformService[] | undefined,
  key: PlatformServiceKey,
): PlatformService | undefined {
  return services?.find((service) => service.key === key)
}
